import * as React from 'react';
import cn from 'classnames';
import ButtonBase, { ButtonBaseProps } from '@mui/material/ButtonBase';
import { useTheme } from '../../../theme';

interface OwnProps {
	size?: 'common' | 'small';

	white?: boolean;
}

export type Props = OwnProps & ButtonBaseProps;

const ActionButton: React.FC<Props> = ({ size = 'common', white, ...props }) => {
	const { ActionButton: css, WhiteButton: whiteButtonStyles } = useTheme('Button');
	const { children, className, onClick, ...restProps } = props;

	return (
		<ButtonBase
			type="button"
			{...restProps}
			className={cn(
				css.button,
				{
					[css.button_small]: size === 'small',
					[whiteButtonStyles.button]: !!white
				},
				className
			)}
			onClick={restProps.disabled ? null : onClick}
		>
			{children}
		</ButtonBase>
	);
};

export default ActionButton;
